export const translations = {
  fr: {
    appTitle: "Exercices de Kegel",
    heroTitle: "Chronomètre Kegel tonus & bien-être",
    seoTitle: "Chronomètre Kegel : tonus musculaire et outil bien-être",
    heroDescription: "Timer guidé pour tonifier les muscles pelviens, suivre votre respiration et ancrer une routine bien-être.",
    heroHighlightsTitle: "Points forts",
    seoDescription: "Outil Kegel interactif pour développer le tonus du plancher pelvien, ajuster vos cycles et vous entraîner sereinement partout.",
    seoKeywords: "chronomètre kegel, tonus musculaire, bien-être pelvien, outil plancher pelvien, timer respiration",
    featureHighlights: [
      "Cycles contraction / relaxation annoncés pour garder un rythme régulier.",
      "Paramètres couleurs, durées et répétitions sauvegardés pour vos séries quotidiennes.",
      "Guide pratique trilingue pour comprendre la méthode et prendre soin de votre tonus."
    ],
    start: "Commencer",
    stop: "Arrêter",
    contraction: "CONTRACTION",
    relaxation: "RELAXATION",
    completed: "Exercice terminé !",
    nextPhaseIn: "Prochaine phase dans",
    programSummary: "Programme : {iterations} cycles ({contractionTime}s contraction / {relaxationTime}s relaxation)",
    settingsTitle: "Paramètres de l'exercice",
    timingSettings: "Réglages du temps",
    contractionTime: "Temps de contraction (secondes)",
    relaxationTime: "Temps de relaxation (secondes)",
    iterationSettings: "Réglages des répétitions",
    iterations: "Nombre de répétitions",
    colorSettings: "Réglages des couleurs",
    contractionColor: "Couleur de contraction",
    relaxationColor: "Couleur de relaxation",
    explanationTitle: "Méthode de Kegel - Guide complet",
    whatIsTitle: "Qu'est-ce que la méthode de Kegel ?",
    whatIsContent: "Les exercices de Kegel consistent à contracter et relâcher les muscles du plancher pelvien.",
    detailedIntroduction: "Les muscles du plancher pelvien soutiennent la vessie, l'utérus et les intestins. Des contractions régulières et contrôlées aident à maintenir leur tonicité, améliorent la continence et participent à la posture.",
    coreMusclesTitle: "Muscles principaux",
    coreMusclesPoints: [
      "Diaphragme pelvien : un hamac musculaire qui soutient les organes internes.",
      "Sphincters urétral et anal : responsables du contrôle des flux urinaires et intestinaux.",
      "Muscles coccygiens : stabilisent le bassin pendant les mouvements.",
      "Transverse de l'abdomen : coopère avec le plancher pelvien pour maintenir une respiration fluide."
    ],
    benefitsTitle: "Bienfaits",
    benefitsContent: "Renforcement du plancher pelvien, amélioration de la continence, meilleure santé sexuelle.",
    stepGuideTitle: "Routine pas à pas",
    stepGuideSteps: [
      "Videz votre vessie et installez-vous dans une position confortable (assis, allongé ou debout).",
      "Identifiez les bons muscles en imaginant stopper un flux urinaire.",
      "Contractez pendant 3 à 5 secondes, en respirant normalement et sans serrer les fessiers ou les cuisses.",
      "Relâchez complètement pendant la même durée pour laisser les muscles récupérer.",
      "Répétez 10 à 15 cycles par série, deux à trois fois par jour selon les recommandations de votre spécialiste."
    ],
    howToTitle: "Comment pratiquer",
    howToContent: "Identifier les bons muscles, contracter pendant 3 secondes, relâcher pendant 3 secondes.",
    whenToAvoidTitle: "Quand faire une pause",
    whenToAvoidPoints: [
      "Douleurs pelviennes persistantes ou apparition de saignements.",
      "Grossesse à haut risque ou post-partum immédiat sans avis médical.",
      "Infections urinaires ou vaginales en cours.",
      "Doutes sur la bonne exécution : consultez un kinésithérapeute spécialisé."
    ],
    accessibilityTitle: "Accessibilité et confort",
    accessibilityContent: "L'application peut être utilisée uniquement au clavier (Tab, Entrée ou Espace). Les couleurs des phases sont renforcées par des contrastes et des indications textuelles. Ajustez les couleurs dans les paramètres pour un meilleur confort visuel.",
    supportTitle: "Besoin d'aide supplémentaire ?",
    supportContent: "En cas de douleur, d'inconfort ou de troubles de la continence, pensez à consulter un professionnel de santé (médecin, sage-femme, kinésithérapeute spécialisé).",
    creatorNoteIntro: "Pour découvrir mes autres projets, rendez-vous sur",
    creatorNoteSupport: "Pour me soutenir, achetez un t-shirt sur",
    settingsNavLabel: "Ouvrir les paramètres",
    explanationNavLabel: "Voir l'explication",
    homeNavLabel: "Retour à l'accueil"
  },
  en: {
    appTitle: "Kegel Exercises",
    heroTitle: "Pelvic floor power timer",
    seoTitle: "Kegel Timer for Muscle Tone & Well-being",
    heroDescription: "Guided Kegel timer built to improve muscle tone, breathing rhythm and daily well-being.",
    heroHighlightsTitle: "Why this trainer works",
    seoDescription: "Practical pelvic floor tool with adjustable cadences, visual timers and calm cues that keep contractions precise.",
    seoKeywords: "kegel timer, pelvic floor muscle tone, wellness routine, breathing tool, contraction chronometer",
    featureHighlights: [
      "Adaptive contraction and relaxation prompts keep every rep consistent.",
      "Color, duration and iteration settings save your preferred routine.",
      "Deep how-to guidance in three languages keeps your technique on point.",
    ],
    start: "Start",
    stop: "Stop",
    contraction: "CONTRACTION",
    relaxation: "RELAXATION",
    completed: "Exercise completed!",
    nextPhaseIn: "Next phase in",
    programSummary: "Program: {iterations} cycles ({contractionTime}s contraction / {relaxationTime}s relaxation)",
    settingsTitle: "Exercise Settings",
    timingSettings: "Timing Settings",
    contractionTime: "Contraction time (seconds)",
    relaxationTime: "Relaxation time (seconds)",
    iterationSettings: "Repetition Settings",
    iterations: "Number of repetitions",
    colorSettings: "Color Settings",
    contractionColor: "Contraction color",
    relaxationColor: "Relaxation color",
    explanationTitle: "Kegel Method - Complete Guide",
    whatIsTitle: "What is the Kegel method?",
    whatIsContent: "Kegel exercises involve contracting and relaxing the pelvic floor muscles...",
    detailedIntroduction: "Your pelvic floor muscles act like a supportive sling for the bladder, uterus and bowel. Regular, controlled contractions help keep these muscles responsive, improve continence and contribute to spinal stability.",
    coreMusclesTitle: "Key muscle groups",
    coreMusclesPoints: [
      "Pelvic floor diaphragm: a hammock-like layer that cradles your organs.",
      "Urethral and anal sphincters: provide on-demand control of bladder and bowel movements.",
      "Coccygeus muscles: assist with pelvic stability during everyday actions.",
      "Transversus abdominis: works with the pelvic floor to steady breathing and posture."
    ],
    benefitsTitle: "Benefits",
    benefitsContent: "Strengthening pelvic floor, improving continence, better sexual health...",
    stepGuideTitle: "Step-by-step routine",
    stepGuideSteps: [
      "Empty your bladder and find a comfortable position (lying, seated or standing).",
      "Locate the correct muscles by imagining you are stopping the flow of urine.",
      "Squeeze for 3–5 seconds while breathing normally and keeping your hips, thighs and glutes relaxed.",
      "Release fully for the same duration, allowing the muscles to recover.",
      "Repeat 10–15 cycles per set, two to three times daily, or as advised by your clinician."
    ],
    howToTitle: "How to practice",
    howToContent: "Identify the right muscles, contract for 3 seconds, relax for 3 seconds...",
    whenToAvoidTitle: "When to pause or seek advice",
    whenToAvoidPoints: [
      "Pelvic pain, unexplained bleeding or discomfort during contractions.",
      "High-risk pregnancy or immediate postpartum without medical guidance.",
      "Active urinary or vaginal infections.",
      "Uncertainty about technique — consult a pelvic health specialist for assessment."
    ],
    accessibilityTitle: "Accessibility tips",
    accessibilityContent: "You can navigate the app entirely with a keyboard (Tab, Enter or Space). Contrast, motion and colour cues complement each other, and you can customise colours in Settings for easier viewing.",
    supportTitle: "Need more support?",
    supportContent: "If you experience pain, incontinence or uncertainty, reach out to a healthcare professional such as a pelvic floor physiotherapist, midwife or physician.",
    creatorNoteIntro: "Explore more of my work at",
    creatorNoteSupport: "Support the project by grabbing a T-shirt from",
    settingsNavLabel: "Open settings",
    explanationNavLabel: "Open explanation",
    homeNavLabel: "Return to home"
  },
  es: {
    appTitle: "Ejercicios de Kegel",
    heroTitle: "Temporizador Kegel para tono y bienestar",
    seoTitle: "Temporizador Kegel: tono muscular y bienestar",
    heroDescription: "Temporizador guiado que refuerza el suelo pélvico, mejora el tono muscular y aporta calma a tu rutina.",
    heroHighlightsTitle: "Ventajas clave",
    seoDescription: "Herramienta práctica para trabajar el suelo pélvico con cadencias ajustables, indicadores claros y cronómetro preciso.",
    seoKeywords: "temporizador kegel, tono muscular, bienestar pélvico, cronómetro contracciones, herramienta suelo pélvico",
    featureHighlights: [
      "Alertas sincronizadas de contracción y relajación mantienen tu ritmo.",
      "Los colores y las duraciones se guardan para repetir la rutina diaria.",
      "Guía educativa clara en español, francés e inglés para cuidar tu tonus.",
    ],
    start: "Comenzar",
    stop: "Detener",
    contraction: "CONTRACCIÓN",
    relaxation: "RELAXACIÓN",
    completed: "¡Ejercicio completado!",
    nextPhaseIn: "Siguiente fase en",
    programSummary: "Programa: {iterations} ciclos ({contractionTime}s contracción / {relaxationTime}s relajación)",
    settingsTitle: "Ajustes del ejercicio",
    timingSettings: "Ajustes de tiempo",
    contractionTime: "Tiempo de contracción (segundos)",
    relaxationTime: "Tiempo de relajación (segundos)",
    iterationSettings: "Ajustes de repeticiones",
    iterations: "Número de repeticiones",
    colorSettings: "Ajustes de color",
    contractionColor: "Color de contracción",
    relaxationColor: "Color de relajación",
    explanationTitle: "Método de Kegel - Guía completa",
    whatIsTitle: "¿Qué es el método de Kegel?",
    whatIsContent: "Los ejercicios de Kegel consisten en contraer y relajar los músculos del suelo pélvico.",
    detailedIntroduction: "El suelo pélvico forma un soporte para vejiga, útero e intestinos. Contraerlo de forma regular y controlada mantiene su fuerza, mejora la continencia y favorece la postura.",
    coreMusclesTitle: "Musculos clave",
    coreMusclesPoints: [
      "Diafragma pélvico: capa muscular que sostiene los órganos internos.",
      "Esfínteres uretral y anal: responsables del control voluntario de la vejiga y el intestino.",
      "Músculos coccígeos: aportan estabilidad a la pelvis durante el movimiento.",
      "Transverso del abdomen: coopera con el suelo pélvico para estabilizar la respiración y la postura."
    ],
    benefitsTitle: "Beneficios",
    benefitsContent: "Fortalecimiento del suelo pélvico, mejora de la continencia, mejor salud sexual.",
    stepGuideTitle: "Rutina paso a paso",
    stepGuideSteps: [
      "Vacía la vejiga y coloca tu cuerpo de forma cómoda (acostado, sentado o de pie).",
      "Identifica los músculos correctos imaginando que detienes el flujo de orina.",
      "Contrae durante 3-5 segundos mientras respiras con normalidad y sin tensar glúteos ni muslos.",
      "Relaja completamente durante el mismo tiempo para permitir la recuperación.",
      "Repite 10-15 ciclos por serie, dos o tres veces al día según la recomendación profesional."
    ],
    howToTitle: "Cómo practicar",
    howToContent: "Identificar los músculos correctos, contraer durante 3 segundos, relajar durante 3 segundos.",
    whenToAvoidTitle: "Cuándo pausar o pedir ayuda",
    whenToAvoidPoints: [
      "Dolor pélvico persistente o sangrado inesperado.",
      "Embarazo de alto riesgo o posparto inmediato sin supervisión médica.",
      "Infecciones urinarias o vaginales activas.",
      "Dudas sobre la técnica: consulta a un fisioterapeuta especializado en suelo pélvico."
    ],
    accessibilityTitle: "Accesibilidad",
    accessibilityContent: "La aplicación admite navegación solo con teclado (Tab, Enter o Espacio). Los colores y textos se combinan para guiar cada fase; ajusta la paleta en Ajustes para mayor comodidad visual.",
    supportTitle: "¿Necesitas más apoyo?",
    supportContent: "Si sientes dolor, incontinencia o dudas, consulta a un profesional de la salud especializado en suelo pélvico.",
    creatorNoteIntro: "Descubre más de mis proyectos en",
    creatorNoteSupport: "Puedes apoyarme comprando una camiseta en",
    settingsNavLabel: "Abrir ajustes",
    explanationNavLabel: "Ver explicación",
    homeNavLabel: "Volver al inicio"
  },
sl: {
    appTitle: "Vadba mišic medeničnega dna “Keglove vaje”",
    heroTitle: "Trener za vadbo mišic medeničnega dna v več jezikih",
    heroDescription: "Vodeni časomer za krepitev medeničnega dna z nastavljivimi cikli, jasnimi namigi in dostopno zasnovo.",
    heroHighlightsTitle: "Prednosti orodja",
    seoDescription: "Spletni časomer za Keglove vaje z osebnimi nastavitvami in večjezičnimi razlagami.",
    seoKeywords: " vadba mišic medeničnega dna, VMMD, trening mišic medeničnega dna, TMMD, keglove vaje, medenično dno, časomer, dihalni tempo, dostopnost",
    featureHighlights: [
      "Sinhroni pozivi za kontrakcijo in sprostitev ohranjajo stalni ritem.",
      "Nastavitve barv, časov in ponovitev shranijo vaše dnevne serije.",
      "Pojasnila Simona Ertela so na voljo v več jezikih."
    ],
    start: "Začni",
    stop: "Ustavi",
    contraction: "STISK",
    relaxation: "SPROŠČANJE",
    completed: "Vaja končana!",
    nextPhaseIn: "Naslednji krog čez",
    programSummary: "Program: {iterations} krogov ({contractionTime}s stisk / {relaxationTime}s sprostitev)",
    settingsTitle: "Nastavitve vaje",
    timingSettings: "Nastavitve časa",
    contractionTime: "Čas stiskanja (sekunde)",
    relaxationTime: "Čas sproščanja (sekunde)",
    iterationSettings: "Nastavitve ponovitev",
    iterations: "Število ponovitev",
    colorSettings: "Nastavitve barv",
    contractionColor: "Barva stiska",
    relaxationColor: "Barva sprostitve",
    explanationTitle: "Keglova metoda - štoparica",
    whatIsTitle: "Kaj je Keglova metoda?",
    whatIsContent: "Keglove vaje vključujejo krčenje in sproščanje mišic medeničnega dna.",
    detailedIntroduction: "Mišice medeničnega dna delujejo kot opora za mehur, maternico in črevesje. Redni in nadzorovani stiski krepijo mišice, izboljšajo zadrževanje urina in stabilizirajo držo.",
    coreMusclesTitle: "Glavne mišične skupine",
    coreMusclesPoints: [
      "Medenično dno: mišična \"mreža\", ki drži notranje organe.",
      "Uretralni in analni sfinkter: skrbita za prostovoljni nadzor nad odvajanjem.",
      "Kokcigealne mišice: pomagajo pri stabilnosti medenice pri gibanju.",
      "Prečni trebušni mišica: sodeluje z medeničnim dnom pri dihanju in drži?."
    ],
    benefitsTitle: "Prednosti",
    benefitsContent: "Krepitev medeničnega dna, izboljšanje kontinence, boljša spolna funkcija.",
    stepGuideTitle: "Vaja korak za korakom",
    stepGuideSteps: [
      "Izpraznite mehur in se udobno namestite (leže, sede ali stoje).",
      "Prepoznajte prave mišice tako, da si predstavljate ustavljanje curka urina.",
      "Stisnite za 3-5 sekund ob normalnem dihanju in brez napenjanja zadnjice ali stegen.",
      "Popolnoma sprostite za enak čas in pustite mišicam, da si odpočijejo.",
      "Ponovite 10-15 ciklov na serijo, dvakrat ali trikrat na dan po priporočilu strokovnjaka."
    ],
    howToTitle: "Kako vaditi",
    howToContent: "Prepoznajte prave mišice, krčite 3 sekunde, sprostite 3 sekunde.",
    whenToAvoidTitle: "Kdaj prenehati ali poiskati nasvet",
    whenToAvoidPoints: [
      "Vztrajna bolečina v medenici ali krvavitev.",
      "Tveganje v nosečnosti ali zgodnje poporodno obdobje brez zdravniškega nadzora.",
      "Aktivne urinarne ali vaginalne okužbe.",
      "Negotovost glede tehnike: obiščite fizioterapevta za medenično dno."
    ],
    accessibilityTitle: "Dostopnost",
    accessibilityContent: "Aplikacijo lahko upravljate samo s tipkovnico (Tab, Enter ali Preslednica). Barve in besedilo se dopolnjujejo, v nastavitvah pa lahko prilagodite paleto za boljšo vidnost.",
    supportTitle: "Potrebujete pomoč?",
    supportContent: "Če se pojavi bolečina ali negotovost, se posvetujte s strokovnjakom za medenično dno.",
    creatorNoteIntro: "Več mojih projektov najdete na",
    creatorNoteSupport: "Podprete me lahko z nakupom majice na",
    settingsNavLabel: "Odpri nastavitve",
    explanationNavLabel: "Odpri pojasnilo",
    homeNavLabel: "Nazaj domov"
  },
  uk: {
    appTitle: "Вправи Кегеля",
    heroTitle: "Багатомовний тренер Кегеля",
    heroDescription: "Керований таймер для м'язів тазового дна з настроюваними циклами, підказками та доступним дизайном.",
    heroHighlightsTitle: "Наші переваги",
    seoDescription: "Онлайн-таймер Кегеля з індивідуальними налаштуваннями, багатомовними рекомендаціями та підтримкою офлайн.",
    seoKeywords: "вправи Кегеля, тазове дно, таймер Кегеля, дихальні підказки, доступність",
    featureHighlights: [
      "Чіткі сигнали для скорочення й розслаблення допомагають тримати рівний темп.",
      "Налаштування кольорів, тривалості та повторів зберігаються для щоденної рутини.",
      "Матеріали Саймона Ертеля перекладені кількома мовами.",
    ],
    start: "Почати",
    stop: "Зупинити",
    contraction: "СКОРОЧЕННЯ",
    relaxation: "РОЗСЛАБЛЕННЯ",
    completed: "Вправу завершено!",
    nextPhaseIn: "Наступна фаза через",
    programSummary: "Програма: {iterations} циклів ({contractionTime}с скорочення / {relaxationTime}с розслаблення)",
    settingsTitle: "Налаштування вправи",
    timingSettings: "Налаштування часу",
    contractionTime: "Тривалість скорочення (секунди)",
    relaxationTime: "Тривалість розслаблення (секунди)",
    iterationSettings: "Налаштування повторів",
    iterations: "Кількість повторів",
    colorSettings: "Налаштування кольорів",
    contractionColor: "Колір скорочення",
    relaxationColor: "Колір розслаблення",
    explanationTitle: "Метод Кегеля — повний гід",
    whatIsTitle: "Що таке метод Кегеля?",
    whatIsContent: "Вправи Кегеля передбачають послідовне напруження та розслаблення м'язів тазового дна.",
    detailedIntroduction: "М'язи тазового дна підтримують сечовий міхур, матку й кишечник. Регулярні контрольовані скорочення зміцнюють м'язи, покращують контроль та підтримують поставу.",
    coreMusclesTitle: "Основні групи м'язів",
    coreMusclesPoints: [
      "Діафрагма тазового дна: підтримує внутрішні органи як гамак.",
      "Сфінктери сечового міхура й ануса: забезпечують контрольований випуск рідин.",
      "Куприкові м'язи: допомагають стабілізувати таз під час руху.",
      "Поперечний м'яз живота: працює разом із тазовим дном для стабілізації дихання й постави."
    ],
    benefitsTitle: "Переваги",
    benefitsContent: "Зміцнення тазового дна, покращення контролю, краща сексуальна функція.",
    stepGuideTitle: "Покрокова рутина",
    stepGuideSteps: [
      "Спорожніть сечовий міхур і займіть зручну позу (лежачи, сидячи або стоячи).",
      "Знайдіть потрібні м'язи, уявивши, що зупиняєте потік сечі.",
      "Стискайте 3–5 секунд, дихаючи рівно та не напружуючи стегна чи сідниці.",
      "Повністю розслабтеся на такий самий час, щоб м'язи відновилися.",
      "Повторіть 10–15 циклів за підхід, 2–3 рази на день або за рекомендацією лікаря."
    ],
    howToTitle: "Як практикувати",
    howToContent: "Знайдіть потрібні м'язи, стискайте 3 секунди, розслабляйте 3 секунди.",
    whenToAvoidTitle: "Коли зробити паузу",
    whenToAvoidPoints: [
      "Тривалий біль у тазі або невідомі виділення крові.",
      "Вагітність із підвищеним ризиком або ранній післяпологовий період без нагляду лікаря.",
      "Активні сечові чи вагінальні інфекції.",
      "Невпевненість у техніці: зверніться до спеціаліста з тазового дна."
    ],
    accessibilityTitle: "Доступність",
    accessibilityContent: "Додатком можна керувати лише клавіатурою (Tab, Enter або Пробіл). Кольори й текст дають паралельні підказки, а в налаштуваннях можна підібрати комфортну палітру.",
    supportTitle: "Потрібна додаткова допомога?",
    supportContent: "Якщо з'явився біль, нетримання чи сумніви, зверніться до лікаря або фізіотерапевта, що спеціалізується на тазовому дні.",
    creatorNoteIntro: "Більше моїх проєктів є на",
    creatorNoteSupport: "Підтримати можна, придбавши футболку на",
    settingsNavLabel: "Відкрити налаштування",
    explanationNavLabel: "Відкрити пояснення",
    homeNavLabel: "Повернутися на головну"
  },
  de: {
    appTitle: "Kegel-Ubungen",
    heroTitle: "Mehrsprachiger Kegel Coach",
    heroDescription: "Gefuhrter Beckenboden Timer mit flexiblen Zyklen, klaren Hinweisen und barrierearmer Gestaltung.",
    heroHighlightsTitle: "Vorteile des Tools",
    seoDescription: "Kostenloser Kegel Timer im Browser mit individuellen Zeitrastern, Erklartexten und mehrsprachiger Unterstutzung.",
    seoKeywords: "kegel uebungen, beckenboden trainer, kegel timer, achtsames atmen, barrierefreiheit",
    featureHighlights: [
      "Synchronisierte Hinweise fur Anspannung und Entspannung halten jedes Set stabil.",
      "Farben, Dauern und Wiederholungen lassen sich speichern und jederzeit anpassen.",
      "Ausfuhrliche Schritt-fur-Schritt-Guides in drei Sprachen sichern eine saubere Technik.",
    ],
    start: "Starten",
    stop: "Stoppen",
    contraction: "ANSPANNUNG",
    relaxation: "ENTSPANNUNG",
    completed: "Ubung abgeschlossen!",
    nextPhaseIn: "Nachste Phase in",
    programSummary: "Programm: {iterations} Durchgänge ({contractionTime}s Anspannung / {relaxationTime}s Entspannung)",
    settingsTitle: "Einstellungen fur die Einheit",
    timingSettings: "Zeitvorgaben",
    contractionTime: "Anspannungszeit (Sekunden)",
    relaxationTime: "Entspannungszeit (Sekunden)",
    iterationSettings: "Durchgangseinstellungen",
    iterations: "Anzahl der Wiederholungen",
    colorSettings: "Farbgestaltung",
    contractionColor: "Farbe fur Anspannung",
    relaxationColor: "Farbe fur Entspannung",
    explanationTitle: "Kegel-Methode - Ausfuhrlicher Leitfaden",
    whatIsTitle: "Was ist die Kegel-Methode?",
    whatIsContent: "Kegel-Ubungen bestehen aus wiederholtem An- und Entspannen der Beckenbodenmuskulatur...",
    detailedIntroduction: "Der Beckenboden wirkt wie eine Stutze fur Blase, Gebarmutter und Darm. Regelmassiges, bewusstes Training erhalt Spannkraft, verbessert die Kontinenz und stabilisiert den Rumpf.",
    coreMusclesTitle: "Wichtige Muskelgruppen",
    coreMusclesPoints: [
      "Beckenbodendiaphragma: haelt die Organe wie eine tragende Hangebrucke.",
      "Urethral- und Analschliessmuskel: geben gezielte Kontrolle uber Blase und Darm.",
      "Musculi coccygei: tragen zur Stabilitat des Beckens im Alltag bei.",
      "Musculus transversus abdominis: arbeitet mit dem Beckenboden fur Atmung und Haltung zusammen."
    ],
    benefitsTitle: "Vorteile",
    benefitsContent: "Starkere Beckenbodenmuskeln, bessere Kontinenz, gesteigertes Korperbewusstsein...",
    stepGuideTitle: "Schritt-fur-Schritt-Routine",
    stepGuideSteps: [
      "Blase entleeren und eine bequeme Position einnehmen (liegen, sitzen oder stehen).",
      "Die richtigen Muskeln finden, als wollten Sie den Urinstrahl anhalten.",
      "3-5 Sekunden anspannen, ruhig weiteratmen und Gesass/Oberschenkel locker lassen.",
      "Ebenso lange komplett loslassen, damit die Muskeln regenerieren.",
      "10-15 Wiederholungen pro Satz, zwei- bis dreimal taglich oder nach Empfehlung."
    ],
    howToTitle: "So uben Sie",
    howToContent: "Richtige Muskeln lokalisieren, 3 Sekunden halten, 3 Sekunden loslassen...",
    whenToAvoidTitle: "Wann pausieren oder Rat holen",
    whenToAvoidPoints: [
      "Anhaltende Beckenschmerzen oder unerwartete Blutungen.",
      "Risikoschwangerschaft oder fruhe Wochen nach der Geburt ohne arztliche Begleitung.",
      "Akute Harnwegs- oder Vaginalinfektionen.",
      "Unsicherheit bei der Technik: Physiotherapie fur den Beckenboden aufsuchen."
    ],
    accessibilityTitle: "Barrierefreiheit",
    accessibilityContent: "Die App lasst sich komplett per Tastatur steuern (Tab, Eingabe oder Leertaste). Farben und Texte liefern parallele Hinweise und lassen sich in den Einstellungen anpassen.",
    supportTitle: "Weitere Unterstutzung?",
    supportContent: "Bei Schmerzen, Inkontinenz oder Zweifeln bitte medizinische Fachpersonen konsultieren, z. B. Physio oder Hebamme.",
    creatorNoteIntro: "Mehr von meinen Projekten finden Sie auf",
    creatorNoteSupport: "Unterstutzen konnen Sie mich mit einem T-Shirt-Kauf auf",
    settingsNavLabel: "Einstellungen offnen",
    explanationNavLabel: "Erklarung offnen",
    homeNavLabel: "Zur Startseite"
  },
  lt: {
    appTitle: "Kegelio pratimai",
    heroTitle: "Daugiakalbis Kegel treneris",
    heroDescription: "Valdomas taimeris dubens dugnui su pritaikomais ciklais, aiskiomis zinutemis ir patogia isvaizda.",
    heroHighlightsTitle: "Pagrindiniai pranasumai",
    seoDescription: "Nemokamas Kegel taimeris internete su individualiais nustatymais ir daugiakalbiais patarimais.",
    seoKeywords: "kegel pratimai, dubens dugnas, taimeris, kvepavimo ritmas, prieinamumas",
    featureHighlights: [
      "Aiskus priminimas apie suspaudima ir atpalaidavima palaiko tolygu tempa.",
      "Irasomi spalvu, trukmes ir kartojimu nustatymai kasdienems serijoms.",
      "Issamus Simono Ertelio turinys isverstas i kelias kalbas.",
    ],
    start: "Pradeti",
    stop: "Sustabdyti",
    contraction: "SUSPAUDIMAS",
    relaxation: "ATPUALAIDAVIMAS",
    completed: "Pratimas baigtas!",
    nextPhaseIn: "Kita faze po",
    programSummary: "Programa: {iterations} ciklų ({contractionTime}s suspaudimas / {relaxationTime}s atpalaidavimas)",
    settingsTitle: "Treniruotes nustatymai",
    timingSettings: "Laiko nustatymai",
    contractionTime: "Suspaudimo trukme (sek.)",
    relaxationTime: "Atsipalaidavimo trukme (sek.)",
    iterationSettings: "Kartojimu nustatymai",
    iterations: "Kartojimu skaicius",
    colorSettings: "Spalvu nustatymai",
    contractionColor: "Suspaudimo spalva",
    relaxationColor: "Atsipalaidavimo spalva",
    explanationTitle: "Kegelio metodas - isamus gidas",
    whatIsTitle: "Kas yra Kegelio metodas?",
    whatIsContent: "Kegelio pratimai yra nuoseklus dubens dugno raumenu sutraukimas ir atpalaidavimas...",
    detailedIntroduction: "Dubens dugno raumenys prilaiko slapimo pusle, gimda ir zarnyna. Reguliarus kontroliuojamas darbas padeda islaikyti tonusa, gerina slapimo sulaikyma ir laikysena.",
    coreMusclesTitle: "Pagrindines raumenu grupes",
    coreMusclesPoints: [
      "Dubens diafragma: tarsi hamakas, laikantis vidaus organus.",
      "Slapimo ir isanges sfinkteriai: leidzia valingai kontroliuoti srautus.",
      "Kokcigeliniai raumenys: stabilizuoja dubeni judejimo metu.",
      "Skersinis pilvo raumuo: dirba kartu su dubens dugnu kviepavimui ir laikysenai."
    ],
    benefitsTitle: "Pranasumai",
    benefitsContent: "Stipresnis dubens dugnas, geresne kontinencija, daugiau pasitikejimo savo kunu...",
    stepGuideTitle: "Zingsnis po zingsnio",
    stepGuideSteps: [
      "Is tuskinkite slapimo pusle ir pasirinkite patogia poza (gulima, sedima ar stovima).",
      "Aptikite tinkamus raumenis – isivaizduokite, kad stabdote slapimo srauta.",
      "Sutraukite 3-5 sekundems, kviepuokite ramiai ir neatpalaiduokite slaunu ar sedmenu.",
      "Tiek pat laiko visiskai atpalaiduokite, kad raumenys pailsetu.",
      "Kartokite 10-15 ciklu du ar tris kartus per diena arba pagal specialisto rekomendacija."
    ],
    howToTitle: "Kaip praktikuoti",
    howToContent: "Suraskite tinkamus raumenis, laikykite 3 s, atpalaiduokite 3 s...",
    whenToAvoidTitle: "Kada sustoti ar kreiptis patarimo",
    whenToAvoidPoints: [
      "Uzsitese dubens skausmai ar netiketas kraujavimas.",
      "Dideles rizikos nestumas ar ankstyvas pogimdyvinis laikotarpis be gydytojo prieziuros.",
      "Aktyvios slapimo taku ar maksties infekcijos.",
      "Neaiski technika: pasitarkite su kineziterapeutu."
    ],
    accessibilityTitle: "Prieinamumas",
    accessibilityContent: "Programa valdoma klaviatura (Tab, Enter arba tarpas). Spalvos ir tekstas dubliuoja signala, nustatymuose galite koreguoti palete.",
    supportTitle: "Reikia pagalbos?",
    supportContent: "Jauciant skausma, slapimo nelaikyma ar abejojant technika, verta pasikonsultuoti su sveikatos specialistu.",
    creatorNoteIntro: "Daugiau mano projektu rasite",
    creatorNoteSupport: "Paremti galite isigydami marskinelius",
    settingsNavLabel: "Atidaryti nustatymus",
    explanationNavLabel: "Ziureti paaiskinima",
    homeNavLabel: "Gristi i pradzia"
  },
  pt: {
    appTitle: "Exercicios de Kegel",
    heroTitle: "Treinador Kegel multilingue",
    heroDescription: "Cronometro guiado para o assoalho pelvico com ciclos personalizaveis, dicas claras e foco em acessibilidade.",
    heroHighlightsTitle: "Diferenciais",
    seoDescription: "Timer de Kegel online com personalizacao completa, suporte multilingue e instrucoes detalhadas.",
    seoKeywords: "exercicio kegel, assoalho pelvico, cronometro kegel, respiracao guiada, acessibilidade",
    featureHighlights: [
      "Alertas sincronizados de contracao e relaxamento mantem o ritmo ideal.",
      "Cores, duracoes e repeticoes ficam salvas para cada sessao.",
      "Guia educativo claro em portugues, frances e ingles ajuda a manter o tonus.",
    ],
    start: "Iniciar",
    stop: "Parar",
    contraction: "CONTRACAO",
    relaxation: "RELAXAMENTO",
    completed: "Exercicio concluido!",
    nextPhaseIn: "Proxima fase em",
    programSummary: "Programa: {iterations} ciclos ({contractionTime}s contração / {relaxationTime}s relaxamento)",
    settingsTitle: "Configuracoes do exercicio",
    timingSettings: "Ajustes de tempo",
    contractionTime: "Tempo de contracao (segundos)",
    relaxationTime: "Tempo de relaxamento (segundos)",
    iterationSettings: "Ajustes de repeticoes",
    iterations: "Numero de repeticoes",
    colorSettings: "Ajustes de cores",
    contractionColor: "Cor da contracao",
    relaxationColor: "Cor do relaxamento",
    explanationTitle: "Metodo Kegel - Guia completo",
    whatIsTitle: "O que e o metodo Kegel?",
    whatIsContent: "Os exercicios de Kegel alternam contracao e relaxamento dos musculos do assoalho pelvico...",
    detailedIntroduction: "Os musculos do assoalho pelvico sustentam a bexiga, utero e intestinos. Contracoes regulares e controladas mantem o tonus, melhoram a continencia e apoiam a postura.",
    coreMusclesTitle: "Grupos musculares principais",
    coreMusclesPoints: [
      "Diafragma pelvico: funciona como uma rede que segura os orgaos.",
      "Esfinteres uretral e anal: controlam fluxos urinarios e intestinais sob comando.",
      "Musculos coccigeos: estabilizam a pelve durante movimentos.",
      "Transverso abdominal: trabalha junto com o assoalho pelvico para respiração e postura."
    ],
    benefitsTitle: "Beneficios",
    benefitsContent: "Fortalecimento do assoalho pelvico, melhor continencia, maior confianca corporal...",
    stepGuideTitle: "Passo a passo",
    stepGuideSteps: [
      "Esvazie a bexiga e encontre uma posicao confortavel (deitado, sentado ou em pe).",
      "Localize os musculos corretos imaginando que interrompe o fluxo de urina.",
      "Contrai por 3-5 segundos, respirando normalmente e sem tensionar quadris ou coxas.",
      "Relaxe completamente pelo mesmo tempo para recuperar os musculos.",
      "Repita 10-15 ciclos por serie, duas ou tres vezes por dia conforme orientacao profissional."
    ],
    howToTitle: "Como praticar",
    howToContent: "Encontre os musculos certos, mantenha 3 s, solte 3 s...",
    whenToAvoidTitle: "Quando fazer pausa",
    whenToAvoidPoints: [
      "Dor pelvica persistente ou sangramentos inesperados.",
      "Gravidez de risco ou pos-parto imediato sem acompanhamento medico.",
      "Infeccoes urinarias ou vaginais ativas.",
      "Duvidas sobre a tecnica: procure um fisioterapeuta especializado."
    ],
    accessibilityTitle: "Acessibilidade",
    accessibilityContent: "O app pode ser usado somente com teclado (Tab, Enter ou Espaco). Cores e textos indicam cada fase e podem ser ajustados nas configuracoes.",
    supportTitle: "Precisa de ajuda?",
    supportContent: "Se sentir dor, incontinencia ou incerteza, procure um profissional de saude especializado em assoalho pelvico.",
    creatorNoteIntro: "Veja mais dos meus projetos em",
    creatorNoteSupport: "Apoie comprando uma camiseta em",
    settingsNavLabel: "Abrir configuracoes",
    explanationNavLabel: "Ver explicacao",
    homeNavLabel: "Voltar ao inicio"
  },
  sv: {
    appTitle: "Kegelovningar",
    heroTitle: "Flersprakig Kegel coach",
    heroDescription: "Vagledd timer for beckenbotten med justerbara cykler, tydliga signaler och tillganglig design.",
    heroHighlightsTitle: "Darfor fungerar appen",
    seoDescription: "Gratis Kegel timer online med personliga installningar, flersprakigt innehall och tydliga instruktioner.",
    seoKeywords: "kegelovningar, beckenbotten, kegel timer, andningstakt, tillganglighet",
    featureHighlights: [
      "Samordnade instruktioner for anspanning och avslappning haller tempot jamnt.",
      "Farger, tider och repetitioner sparas for dina dagliga pass.",
      "Omfattande guider pa flera sprak hjalper dig att behalla ett starkt tonus.",
    ],
    start: "Starta",
    stop: "Stoppa",
    contraction: "ANSPANNING",
    relaxation: "AVSLAPPNING",
    completed: "Ovningen ar klar!",
    nextPhaseIn: "Nasta fas om",
    programSummary: "Program: {iterations} cykler ({contractionTime}s anspänning / {relaxationTime}s avslappning)",
    settingsTitle: "Installningar for ovningen",
    timingSettings: "Tidsinstallningar",
    contractionTime: "Tid for anspanning (sekunder)",
    relaxationTime: "Tid for avslappning (sekunder)",
    iterationSettings: "Omgangsinstallningar",
    iterations: "Antal repetitioner",
    colorSettings: "Farginstallningar",
    contractionColor: "Farg for anspanning",
    relaxationColor: "Farg for avslappning",
    explanationTitle: "Kegelmetoden - komplett guide",
    whatIsTitle: "Vad ar Kegelmetoden?",
    whatIsContent: "Kegelovningar innebar att spanna och slappa beckenbottenmusklerna i cykler...",
    detailedIntroduction: "Beckenbotten fungerar som ett stod for urinblasam livmoder och tarm. Regelbunden kontroll ger battra kontinenz och stabilitet i overkroppen.",
    coreMusclesTitle: "Viktiga muskelgrupper",
    coreMusclesPoints: [
      "Beckenbottendiafragman: som ett hamn for dina organ.",
      "Urinrors- och analspinkter: ger viljestyrd kontroll over floden.",
      "Coccygeala muskler: hjalper till att stabilisera beckenet i rorelse.",
      "Transversus abdominis: samarbetar med beckenbotten for andning och hallning."
    ],
    benefitsTitle: "Forder",
    benefitsContent: "Starkare beckenbotten, battre kontroll, okad kroppsmedvetenhet...",
    stepGuideTitle: "Steg for steg",
    stepGuideSteps: [
      "Tomm urinblasen och inta en bekvam position (liggande, sittande eller stande).",
      "Hitta ratt muskler genom att forestalla dig att du stoppar ett urinflode.",
      "Spann i 3-5 sekunder med lugn andning och avslappnade ben och skinkor.",
      "Slapp helt lika lange sa musklerna hinner aterhamta sig.",
      "Upprepa 10-15 cykler per sats, tva till tre ganger per dag eller enligt rad."
    ],
    howToTitle: "Sa gor du",
    howToContent: "Hitta musklerna, hall i 3 s, slapp i 3 s...",
    whenToAvoidTitle: "Nar du bor pausa",
    whenToAvoidPoints: [
      "Langvarig beckenbottensmart eller oforklarade blodningar.",
      "Riskgraviditet eller tidig postpartum utan lakarstodd.",
      "Aktiva urinvags- eller vaginalinfektioner.",
      "Osaker teknik: kontakta en beckenbottenterapeut."
    ],
    accessibilityTitle: "Tillganglighet",
    accessibilityContent: "Appen kan styras helt med tangentbord (Tabb, Enter eller Mellanslag). Farg och text ger parallella signaler och kan justeras i Installningar.",
    supportTitle: "Behov av mer stodd?",
    supportContent: "Vid smarta, inkontinens eller osakerhet, radfraga lakare, barnmorska eller fysioterapeut.",
    creatorNoteIntro: "Se fler av mina projekt pa",
    creatorNoteSupport: "Stod projektet genom att kopa en t-shirt pa",
    settingsNavLabel: "Oppna installningar",
    explanationNavLabel: "Oppna forklaring",
    homeNavLabel: "Till startsidan"
  }
};
